import { useEffect } from "react"

export const useMapboxCss = () => {
  useEffect(() => {
    void import("@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css")
    void import("mapbox-gl/dist/mapbox-gl.css")
  }, [])
}
